import React from 'react';
import '../style/about.css';
import { Container, Row, Col } from 'react-bootstrap';
import thankyou from '../assets/thankyou.png';

const Expired = () => {
  return (
    <div>
    <section className="thankyoubanner" >
     <Container>
        <Row>
            <Col md={12}>
               {/* <img src={thankyou} /> */}
               Your Stripe Connect signup link appears to have expired.<br />
               <br />
               Open the LocalRoots app, navigate to the Profile {'>'} Vendor tab, and tap the "Re-send Stripe Connect Link" button<br />
               {/* <a href='/'>Back To Home</a> */}
            </Col>
        </Row>
     </Container>
    </section>
    </div>
  );
};


export default Expired;
